import React, { memo } from 'react';
interface PromoBanner {
  id: number;
  image: string;
}
const promoBanners: PromoBanner[] = [{
  id: 1,
  image: ''
}, {
  id: 2,
  image: ''
}, {
  id: 3,
  image: ''
}];
export const PromoBanners = memo(function PromoBanners() {
  return <div className="container mx-auto px-4" data-id="element-2075" data-mp="l4uuox8cppi5">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4" data-id="element-2076" data-mp="g7clr6uc3aa5">
        {promoBanners.map(banner => <div key={banner.id} className="relative aspect-[3/1] overflow-hidden rounded-lg bg-gray-300" data-id="element-2077" data-mp="3oophra2hysrx">
            {banner.image && <img src={banner.image} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-2078" data-mp="3jmhz61n5wegm" />}
            <div className="absolute inset-0 flex flex-col justify-center p-4 text-gray-800 md:p-6" data-id="element-2079" data-mp="35wmu3erfuc86">
              <span className="mb-2 w-max rounded bg-white px-2 py-0.5 text-xs font-bold text-gray-600" data-id="element-2080" data-mp="30ylamsq3oaw6">
                DIMENSIONS
              </span>
              <h2 className="mb-1 text-lg font-bold md:text-2xl" data-id="element-2081" data-mp="3tv9188wijmyi">1/3 WIDTH</h2>
              <p className="text-xs font-medium md:text-sm" data-id="element-2082" data-mp="2phbvbqk8ecr">ASPECT RATIO 3:1</p>
            </div>
          </div>)}
      </div>
    </div>;
});